import { Component, OnInit } from '@angular/core';
import { JsonService } from '../_services/json.service';
import { DialogService } from '../dialog/dialog.service';
import { LoggerService } from '../_services/logger.service';

@Component({
  selector: 'app-grupo-usuarios',
  templateUrl: './grupo-usuarios.component.html',
  styleUrl: './grupo-usuarios.component.scss'
})
export class GrupoUsuariosComponent {
  public groupList: Array<any> = [];
  public groupUser: Array<any> = [];
  public groupUserByGroup: Array<any> = [];
  public listaRegiao: Array<any> = [];
  public grupoSelecionado: string = '';
  public usuarioSelecionado: string = '';
  public groupName: string = '';
  public groupPeso: string = '';
  public regiaoSelecionada: string = '';

  public newGroup: any = {
    name: '',
    description: ''
  };

  constructor(
    private jsonService: JsonService,
    private logger: LoggerService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.loadGoups();
    this.loadUsers();
    this.jsonService.getRegiao().subscribe(
      resp => {
        this.listaRegiao = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar regiões', erro);
      }
    );

    this.jsonService.listGroupUsers().subscribe(
      resp => {
        this.groupUserByGroup = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar usuários por grupo', erro);
      }
    );
  }

  adicionarUsuarioAoGrupo() {
    let formData = new FormData();
    formData.append('groupId', this.grupoSelecionado);
    formData.append('userId', this.usuarioSelecionado);
    this.jsonService.createAssociation(formData).subscribe(
      resp => {
        this.dialogService.abrirDialog('aviso', 'Éxito!', 'Usuario agregado exitosamente!');
      },
      erro => {
        this.logger.error('Erro ao adicionar usuário ao grupo', erro);
      }
    );
  }
  removerUsuarioAoGrupo() {
      let formData = new FormData();
      formData.append('groupId', this.grupoSelecionado);
      formData.append('userId', this.usuarioSelecionado);
    this.jsonService.removeAssociation(formData).subscribe(
      resp => {
        this.dialogService.abrirDialog('aviso', 'Éxito!', 'Usuario eliminado exitosamente!');
      },
      erro => {
        this.logger.error('Erro ao remover usuário do grupo', erro);
      }
    );
  }
  adicionarGrupo() {
    let formData = new FormData();
    formData.append('Name', this.groupName);
    formData.append('RegionId', this.regiaoSelecionada);
    formData.append('weight', this.groupPeso);
    this.jsonService.createGroup(formData).subscribe(
      resp => {
        this.loadGoups();
        this.dialogService.abrirDialog('aviso', 'Éxito!', 'Grupo creado exitosamente!');
      },
      erro => {
        this.logger.error('Erro ao criar grupo', erro);
      }
    );
  }

  loadGoups() {
    this.jsonService.getGroupList().subscribe(
      resp => {
        this.groupList = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar grupos', erro);
      }
    );
  }
  loadUsers() {
    this.jsonService.listGroupUsers().subscribe(
      resp => {
        this.groupUser = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar usuários', erro);
      }
    );
  }
}
